export class RequiredByRefCount {
  protected counter: {
    [id: string]: number;
  };

  constructor(...args: string[]) {
    this.counter = {};
    for (const arg of args) {
      if (arg) {
        this.refBy(arg);
      }
    }
  }

  update(other: RequiredByRefCount) {
    if (other instanceof RequiredByRefCount) {
      for (const [id, count] of Object.entries(other.counter)) {
        this._updateOne(id, count);
      }
    }
    return this;
  }

  refBy(id: string) {
    return this._refBy(id, 1);
  }

  unrefBy(id: string) {
    return this._unrefBy(id, 1);
  }

  has(id: string) {
    return id in this.counter;
  }

  get(id: string) {
    return this.counter[id];
  }

  isEmpty() {
    return Object.keys(this.counter).length === 0;
  }

  numRefs() {
    const keys = Object.keys(this.counter);
    if (keys.length > 0) {
      return keys.reduce((total, key) => total + this.counter[key], 0);
    }
  }

  shouldGc() {
    return this.numRefs() === 0;
  }

  protected _updateOne(id: string, count: number) {
    if (count < 0) {
      this._unrefBy(id, count);
    } else {
      this._refBy(id, count);
    }
  }

  protected _refBy(id: string, count: number) {
    this.counter[id] = (this.counter[id] ?? 0) + count;
  }

  protected _unrefBy(id: string, count: number) {
    if (!this.counter[id] || this.counter[id] < count) {
      // eslint-disable-next-line no-console
      console.error(
        `[RequiredByRefCount] Invalid unref on ${id} with ${count}. Current count is ${this.counter[id]}`,
      );
      return;
    }
    this.counter[id] -= count;
  }
}
